import { InjectionToken } from '@angular/core';
import { BusinessServices } from '@shs-digi-care-monorepo/interfaces';

/**
 * The business service the running frontend serves. Every app covers exactly one - EMEA, NAM and
 * IRO are deployed separately - so anything asking the backend "which users do I administer" has
 * to name it.
 */
export const APP_BUSINESS_SERVICE = new InjectionToken<BusinessServices>('APP_BUSINESS_SERVICE');
